/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CspSubAccount
 */
export interface CspSubAccount {
  /**
   *
   * @type {string}
   * @memberof CspSubAccount
   */
  code?: string;
  /**
   *
   * @type {string}
   * @memberof CspSubAccount
   */
  label?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof CspSubAccount
   */
  laneWhitelist?: Array<string>;
}

/**
 * Check if a given object implements the CspSubAccount interface.
 */
export function instanceOfCspSubAccount(value: object): value is CspSubAccount {
  return true;
}

export function CspSubAccountFromJSON(json: any): CspSubAccount {
  return CspSubAccountFromJSONTyped(json, false);
}

export function CspSubAccountFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CspSubAccount {
  if (json == null) {
    return json;
  }
  return {
    code: json["code"] == null ? undefined : json["code"],
    label: json["label"] == null ? undefined : json["label"],
    laneWhitelist:
      json["laneWhitelist"] == null ? undefined : json["laneWhitelist"],
  };
}

export function CspSubAccountToJSON(json: any): CspSubAccount {
  return CspSubAccountToJSONTyped(json, false);
}

export function CspSubAccountToJSONTyped(
  value?: CspSubAccount | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    code: value["code"],
    label: value["label"],
    laneWhitelist: value["laneWhitelist"],
  };
}
